(function() {
  'use strict';

  /* Wireless Prepaid Controller - START */
  eclipseApp.controller('prepaidWLDashboardCtrl', [
    '$scope',
    '$modal',
    '$http',
    '$state',
    '$window',
    '$stateParams',
    '$filter',
    '$sessionStorage',
    'uteModal',
    'uteLocale',
    'commonService',
    'httpService',
    'prepaidAirtimeBalanceService',
    'prepaidAutoRefillInfoService',
    'prepaidPlanInfoService',
    'prepaidRegisteredCCInfoService',
    'prepaidUserInfoService',
    'usageService',
    'lostStolenDeviceService',
    'env',
    '$rootScope',
    'dtmService',
    'dtmServiceConstants',
    'TokenService',
    'permissionsService',
    'ute.datalayer.common.service',
    function(
      $scope,
      $modal,
      $http,
      $state,
      $window,
      $stateParams,
      $filter,
      $sessionStorage,
      uteModal,
      uteLocale,
      commonService,
      httpService,
      prepaidAirtimeBalanceService,
      prepaidAutoRefillInfoService,
      prepaidPlanInfoService,
      prepaidRegisteredCCInfoService,
      prepaidUserInfoService,
      usageService,
      lostStolenDeviceService,
      env,
      $rootScope,
      dtmService,
      dtmServiceConstants,
      tokenService,
      permissionsService,
      dataLayerService
    ) {
      var ssoToken = '';
      $scope.activeCTA = function() {
        return false;
      };
      $scope.rlhLanguage = uteLocale.language.toLowerCase();
      $scope.vicelandLink = null;
      $scope.vicelandLearnMore = function() {
        if ($scope.rlhLanguage === 'en') {
          $scope.vicelandLink = env.enFidoVice;
        } else {
          $scope.vicelandLink = env.frFidoVice;
        }
      };
      $scope.vicelandLearnMore();

      console.log('Inside prepaidWLDashboardCtrl');

      if ($stateParams.accountNumber && $stateParams.subscriberNo) {
        $rootScope.userInfo.selectedAccountNumber = $stateParams.accountNumber;
        $rootScope.userInfo.selectedSubscriberNo = $stateParams.subscriberNo;
      } else if (
        (!$stateParams.accountNumber && !$rootScope.userInfo.selectedAccountNumber) ||
        (!$stateParams.subscriberNo && !$rootScope.userInfo.selectedSubscriberNo)
      ) {
        $state.go('myAccount.overview');
      } else {
        if (!$stateParams.accountNumber) {
          $stateParams.accountNumber = $rootScope.userInfo.selectedAccountNumber;
        }
        if (!$stateParams.subscriberNo) {
          $stateParams.subscriberNo = $rootScope.userInfo.selectedSubscriberNo;
        }
      }

      $scope.$extend({
        accountDetails: commonService.accountDetails,
        selectedBAN: $stateParams.accountNumber,
        selectedCTN: $stateParams.subscriberNo,
        lostDeviceStatus: false,
        losEnabled: false,
        $storage: $sessionStorage,
        language: uteLocale.language,
        subscriberNumberList: [],
        planDesc: null,
        planDataIncluded: null,
        planUOM: null,
        planPrice: null,
        planTerm: null,
        planfeatures: null,
        planAndAddOnInfo: null,
        addonListInfo: null,
        masterAddonListInfo: null,
        autoRefillSubscriptionInfo: null,
        fidoRewardsInfo: null,
        deviceInfo: null,
        redeemURLInfo: null,
        planAndAddOnInfoError: null,
        addonListInfoError: null,
        autoRefillSubscriptionInfoError: null,
        fidoRewardsInfoError: null,
        deviceInfoError: null,
        redeemURLInfoError: null,
        bringYourOwnPhoneLink: null,
        voiceMailIndicator: false,
        localMins: 0,
        userEmailId: '',
        userProvince: '',

        dropDownChanged: function() {
          //alert('dropDownChanged :: '+$scope.selectedCTN);
          console.log('dropDownChanged :: ' + $scope.selectedCTN);
          $scope.relaunchPage();
        },

        getPlanAndAddOnInfo: function(accountNumber, subscriberNumber, language) {
          var promise = httpService.send(
            'v1/wireless/prepaid/dashboard/plan', // TODO : Need to change
            {
              accountNumber: accountNumber,
              ctn: subscriberNumber,
              language: language
            }
          );

          promise.then(
            function(result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.planAndAddOnInfoError = true;
              } else {
                //alert('Got PlanAndAddOnInfo Successfully');
                $scope.planAndAddOnInfo = result.data;
                console.log('$scope.planAndAddOnInfo :: ' + $scope.planAndAddOnInfo);
                prepaidAirtimeBalanceService.setAirTimeBalance($scope.planAndAddOnInfo.airtimeBalance);
                prepaidAirtimeBalanceService.setExpiryDate($scope.planAndAddOnInfo.expiryDate);
                $scope.expDate = $scope.planAndAddOnInfo.expiryDate;
                //$scope.formattedDate = new Date($scope.expDate);
                $scope.formattedDate = $scope.expDate;
                prepaidPlanInfoService.setAirTimePlanFee($scope.planAndAddOnInfo.pricePlan);
                $scope.pricePlanInfo = null;
                if (result.data.planDetailsInfo != null) {
                  if ($scope.language === 'en' || $scope.language === 'EN') {
                    $scope.pricePlanInfo = result.data.planDetailsInfo.en;
                  } else {
                    $scope.pricePlanInfo = result.data.planDetailsInfo.fr;
                  }
                  if (result.data.planDetailsInfo.productId != null && result.data.planDetailsInfo.productId != '') {
                    prepaidPlanInfoService.setAirTimePlanSoc(result.data.planDetailsInfo.productId);
                  } else {
                    prepaidPlanInfoService.setAirTimePlanSoc($scope.planAndAddOnInfo.planSoc);
                  }
                  if (
                    $scope.pricePlanInfo != null &&
                    $scope.pricePlanInfo.planComparison != null &&
                    $scope.pricePlanInfo.planComparison.planTitle != null &&
                    $scope.pricePlanInfo.planComparison.planTitle != ''
                  ) {
                    prepaidPlanInfoService.setAirTimePlanTitle($scope.pricePlanInfo.planComparison.planTitle);
                  } else {
                    if ($scope.language === 'en' || $scope.language === 'EN') {
                      prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.description);
                    } else {
                      prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.descriptionFr);
                    }
                  }
                } else {
                  if ($scope.language === 'en' || $scope.language === 'EN') {
                    prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.description);
                  } else {
                    prepaidPlanInfoService.setAirTimePlanTitle($scope.planAndAddOnInfo.descriptionFr);
                  }
                  prepaidPlanInfoService.setAirTimePlanSoc($scope.planAndAddOnInfo.planSoc);
                }
                $scope.planDesc = prepaidPlanInfoService.getAirTimePlanTitle();
                prepaidPlanInfoService.setAirTimePlanFeatures($scope.pricePlanInfo);
                $scope.getAutoRefillSubscriptionInfo(
                  prepaidUserInfoService.getBAN(),
                  prepaidUserInfoService.getCTN(),
                  $scope.language
                );
              }
            },
            function(reason) {
              $scope.planAndAddOnInfoError = true;
            }
          );
        },

        getAddonListInfo: function(accountNumber, subscriberNumber, language) {
          var promise = httpService.send(
            'v1/wireless/prepaid/dashboard/addOn', // TODO : Need to change
            {
              accountNumber: accountNumber,
              ctn: subscriberNumber,
              language: language
            }
          );

          promise.then(
            function(result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.addonListInfoError = true;
              } else {
                var addonListInfo = result.data;
                var masterAddonList;
                if (addonListInfo != null) {
                  if (addonListInfo.addonDetailList != null) {
                    masterAddonList = addonListInfo.addonDetailList;
                    if (addonListInfo.addOnJsonList != null) {
                      _.each(addonListInfo.addOnJsonList, function(addOnJsonInfo) {
                        _.each(addonListInfo.addonDetailList, function(addonDetailInfo) {
                          if (addOnJsonInfo.productId == addonDetailInfo.productCode) {
                            addonDetailInfo.contentInfo = addOnJsonInfo;
                          }
                        });
                      });
                      masterAddonList = addonListInfo.addonDetailList;
                    }
                  } else {
                    if (addonListInfo.addOnJsonList != null) {
                      masterAddonList = addonListInfo.addOnJsonList;
                    } else {
                      $scope.addonListInfoError = true;
                    }
                  }
                } else {
                  $scope.addonListInfoError = true;
                }
                $scope.masterAddonListInfo = masterAddonList;
                console.log('$scope.masterAddonListInfo :: ' + $scope.masterAddonListInfo);
              }
            },
            function(reason) {
              $scope.addonListInfoError = true;
            }
          );
        },

        getAutoRefillSubscriptionInfo: function(accountNumber, subscriberNumber, language) {
          var promise = httpService.send(
            'v1/refill/autorefill/scheduled/details', // TODO : Need to change
            {
              accountNumber: accountNumber,
              ctn: subscriberNumber,
              language: language
            }
          );

          promise.then(
            function(result) {
              if (result.data.error || result.data.error != '') {
                $scope.autoRefillSubscriptionInfoError = true;
                console.log('AutoRefillSubscriptionInfo Error');
              } else {
                console.log('Got AutoRefillSubscriptionInfo Successfully');
                $scope.autoRefillSubscriptionInfo = result.data;
                console.log('$scope.autoRefillSubscriptionInfo :: ' + $scope.autoRefillSubscriptionInfo);
                prepaidAutoRefillInfoService.setAutoPayPlanInfo($scope.autoRefillSubscriptionInfo.autoPayPlan);
                prepaidAutoRefillInfoService.setAutoRefillBalanceInfo(
                  $scope.autoRefillSubscriptionInfo.autoRefillBalance
                );
                var $translate = $filter('translate');
                var $currency = $filter('currency');
                if (prepaidAutoRefillInfoService.getAutoPayPlanInfo().registeredFlag) {
                  var $date = $filter('date');
                  var scheduledRefillDate = new Date($scope.autoRefillSubscriptionInfo.autoPayPlan.rechargeDate);
                  $scope.autoRefillSubscriptionInfo.autoPayPlan.rechargeDate = scheduledRefillDate;
                  prepaidAutoRefillInfoService.setAutoPayPlanSubContent(
                    '<p class="fido-tick-icon">' +
                      $translate('global.label.nextPaymentOf') +
                      ' ' +
                      $currency(prepaidAutoRefillInfoService.getAutoPayPlanInfo().rechargeAmount) +
                      '</p><p>' +
                      $translate('global.label.autoPayPlanBridge') +
                      ' ' +
                      $date(scheduledRefillDate, 'MMMM dd, yyyy') +
                      '</p>'
                  );
                  prepaidAutoRefillInfoService.setAutoPayPlanContentClass(
                    'tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-2'
                  );
                  if (prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag) {
                    prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent(
                      '<p class="fido-tick-icon-secondary">' +
                        $translate('global.label.add') +
                        ' ' +
                        $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().rechargeAmount) +
                        ' ' +
                        $translate('global.label.autoRefillBalanceBridge') +
                        ' ' +
                        $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().balanceThreshold) +
                        '</p>'
                    );
                    prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass(
                      'tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-9'
                    );
                  } else {
                    prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('');
                    prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5');
                  }
                } else {
                  prepaidAutoRefillInfoService.setAutoPayPlanSubContent('');
                  prepaidAutoRefillInfoService.setAutoPayPlanContentClass('tab pp-refill-margin-top-1-5');
                  if (prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().registeredFlag) {
                    prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent(
                      '<p class="fido-tick-icon-secondary">' +
                        $translate('global.label.add') +
                        ' ' +
                        $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().rechargeAmount) +
                        ' ' +
                        $translate('global.label.autoRefillBalanceBridge') +
                        ' ' +
                        $currency(prepaidAutoRefillInfoService.getAutoRefillBalanceInfo().balanceThreshold) +
                        '</p>'
                    );
                    prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass(
                      'tab pp-refill-margin-top-1-5 pp-refill-padding-top-0-9'
                    );
                  } else {
                    prepaidAutoRefillInfoService.setAutoRefillBalanceSubContent('');
                    prepaidAutoRefillInfoService.setAutoRefillBalanceContentClass('tab pp-refill-margin-top-1-5');
                  }
                }
              }
            },
            function(reason) {
              $scope.autoRefillSubscriptionInfoError = true;
            }
          );
        },

        getFidoRewardsInfo: function(accountNumber, subscriberNumber, language) {
          var promise = httpService.send(
            'v1/wireless/prepaid/dashboard/fidorewards', // TODO : Need to change
            {
              accountNumber: accountNumber,
              ctn: subscriberNumber,
              language: language
            }
          );

          $scope.fidoDollarAmountCheck = false;

          promise.then(
            function(result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.fidoRewardsInfoError = true;
              } else {
                //alert('Got FidoRewardsInfo Successfully');
                $scope.fidoRewardsInfo = result.data;
                //console.log('$scope.fidoRewardsInfo :: ' + $scope.fidoRewardsInfo);
                //console.log('$scope.fidoRewardsInfo.fidoDollarAmount:: '+$scope.fidoRewardsInfo.fidoDollarAmount);

                if ($scope.fidoRewardsInfo.fidoDollarAmount >= 0 && $scope.fidoRewardsInfo.fidoDollarAmount !== null) {
                  $scope.fidoDollarAmountCheck = true;
                }
              }
            },
            function(reason) {
              $scope.fidoRewardsInfoError = true;
            }
          );
        },

        getDeviceInfo: function(accountNumber, subscriberNumber, language) {
          var promise = httpService.send(
            'v1/wireless/prepaid/dashboard/devicedetails', // TODO : Need to change
            {
              accountNumber: accountNumber,
              ctn: subscriberNumber,
              language: language
            }
          );

          promise.then(
            function(result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.deviceInfoError = true;
              } else {
                //alert('Got DeviceInfo Successfully');
                if (angular.isDefined(result.data) && result.data != null) {
                  $scope.voiceMailIndicator = result.data.voiceMailIndicator;
                  if (result.data.deviceDetail != null) {
                    if ($scope.language === 'en' || $scope.language === 'EN') {
                      $scope.deviceInfo = result.data.deviceDetail.en;
                    } else {
                      $scope.deviceInfo = result.data.deviceDetail.fr;
                    }
                    lostStolenDeviceService.setDeviceDetails(result.data.deviceDetail);
                    console.log('$scope.deviceInfo :: ' + $scope.deviceInfo);
                  }
                }
              }
            },
            function(reason) {
              $scope.deviceInfoError = true;
            }
          );
        },

        retrieveCreditCardRegistrationInfo: function(accountNumber, subscriberNumber, stateName) {
          var promise = httpService.send(
            'v1/wireless/prepaid/creditcard/retrieve/ccinfo', // TODO : Need to change
            {
              accountNumber: accountNumber,
              ctn: subscriberNumber
            }
          );

          promise.then(
            function(result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.creditCardRegistrationInfoError = true;
              } else {
                //alert('Got userInfo Successfully');
                $scope.creditCardRegistrationInfo = result.data;
                if ($scope.creditCardRegistrationInfo.registrationStatus) {
                  //prepaidRegisteredCCInfoService.setCardScheme($scope.creditCardRegistrationInfo.creditCardInfo.cardType);
                  prepaidRegisteredCCInfoService.setTokenizedCCNumber(
                    $scope.creditCardRegistrationInfo.creditCardInfo.creditCardNo
                  );
                  prepaidRegisteredCCInfoService.setMonth($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                  prepaidRegisteredCCInfoService.setYear($scope.creditCardRegistrationInfo.creditCardInfo.expiryDate);
                }
                prepaidRegisteredCCInfoService.setCreditCardRegistrationStatus(
                  $scope.creditCardRegistrationInfo.registrationStatus
                );
                $scope.retrieveUserInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), stateName);
              }
            },
            function(reason) {
              $scope.creditCardRegistrationInfoError = true;
            }
          );
        },

        retrieveUserInfo: function(accountNumber, subscriberNumber, stateName) {
          var promise = httpService.send(
            'v1/wireless/prepaid/creditcard/retrieve/userinfo', // TODO : Need to change
            {
              accountNumber: accountNumber,
              ctn: subscriberNumber
            }
          );

          promise.then(
            function(result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.userInfoError = true;
              } else {
                //alert('Got userInfo Successfully');
                $scope.userInfo = result.data;
                console.log('$scope.userInfo :: ' + $scope.userInfo);
                prepaidUserInfoService.setFirstName($scope.userInfo.firstName);
                prepaidUserInfoService.setLastName($scope.userInfo.lastName);
                prepaidUserInfoService.setEmailAddress($scope.userInfo.emailAddress);
                prepaidUserInfoService.setBillingAddress($scope.userInfo.billingAddress);
                //alert('stateName :: '+stateName);
                $state.go(stateName);
              }
            },
            function(reason) {
              $scope.userInfoError = true;
            }
          );
        },

        retrieveRedeemURL: function(accountNumber, subscriberNumber, language) {
          var promise = httpService.send(
            'v1/wireless/redeem/fidodollars', // TODO : Need to change
            {
              accountNumber: accountNumber,
              ctn: subscriberNumber,
              language: language
            }
          );

          promise.then(
            function(result) {
              if (result.data.error || result.data.status == 'Failed') {
                $scope.redeemURLInfoError = true;
              } else {
                //alert('Got userInfo Successfully');
                $scope.redeemURLInfo = result.data;
                console.log('$scope.redeemURLInfo :: ' + $scope.redeemURLInfo.micrositeURL);
              }
            },
            function(reason) {
              $scope.redeemURLInfoError = true;
            }
          );
        },

        loadAutoPayPlanInfo: function() {
          $scope.retrieveCreditCardRegistrationInfo(
            prepaidUserInfoService.getBAN(),
            prepaidUserInfoService.getCTN(),
            'myAccount.prepaidRefill.autoPayPlan'
          );
        },

        loadAutoRefillBalanceInfo: function() {
          $scope.retrieveCreditCardRegistrationInfo(
            prepaidUserInfoService.getBAN(),
            prepaidUserInfoService.getCTN(),
            'myAccount.prepaidRefill.autoRefillBalance'
          );
        },

        openEmbarrassingWindow: function() {
          /*var modalConfig = {
             templateUrl: 'modules/my-account/embarrassing-modal.html',
             controller: function ($scope, $modalInstance) {
             $scope.ok = function () {
             $modalInstance.close();
             };
             $scope.cancel = function () {
             $modalInstance.dismiss('cancel');
             };
             },
             ok: function () {
             },
             cancel: function () {
             }
             };*/
          // show modal
          //uteModal.open(modalConfig);
          uteModal.open({
            templateUrl: 'modules/my-account/embarrassing-modal.html',
            /*controller: function ($scope, $modalInstance) {
               $scope.ok = function () {
               $modalInstance.close();
               };
               $scope.cancel = function () {
               $modalInstance.dismiss('cancel');
               };
               },*/
            ok: function() {},
            cancel: function() {}
          });
        },

        relaunchPage: function() {
          prepaidUserInfoService.setCTN($scope.selectedCTN);
          prepaidUserInfoService.setBAN($scope.selectedBAN);
          $scope.$storage.selectedCTN = $scope.selectedCTN;
          $scope.$storage.selectedBAN = $scope.selectedBAN;
          $scope.getPlanAndAddOnInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), $scope.language);
          $scope.getAddonListInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), $scope.language);
          //Commented the Fido rewards call as part of Fido dollars Sunset
          //$scope.retrieveRedeemURL(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), $scope.language);
          //$scope.getFidoRewardsInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), $scope.language);
          $scope.fidoDollarAmountCheck = false;
          $scope.getDeviceInfo(prepaidUserInfoService.getBAN(), prepaidUserInfoService.getCTN(), $scope.language);

          //FUSS-2096 DTM changes for CTN
          dtmService.setVar(dtmServiceConstants.dtmRules.selectedCTN.parameterName, $scope.selectedCTN);
          dtmService.direct(dtmServiceConstants.dtmRules.selectedCTN.ruleName);
        }
      });

      console.log('accountDetails :: ' + $scope.accountDetails);
      angular.forEach($scope.accountDetails, function(accountDetailValue, accountDetailKey) {
        if ($scope.selectedBAN === accountDetailValue.accountNumber) {
          // viewFidoRewardsBeanService.setBillingCycleDate(accountDetailValue.billCycleDate);
          // viewFidoRewardsBeanService.setLob(accountDetailValue.LOB);
          lostStolenDeviceService.setContactEmail(accountDetailValue.contactEmail);
          lostStolenDeviceService.setAccountNumber(accountDetailValue.accountNumber);
          $scope.userEmailId = accountDetailValue.contactEmail;

          $scope.losEnabled = accountDetailValue.losEnabled;
          angular.forEach(accountDetailValue.subscriberServices, function(
            subscriberServiceValue,
            subscriberServiceKey
          ) {
            $scope.userProvince = subscriberServiceValue.serviceAddress.province;
            //console.log("subscriberServiceValue.wireless.subscriberNo :: "+subscriberServiceValue.wireless.subscriberNo);
            //alert("subscriberServiceValue.wireless.subscriberNo :: "+subscriberServiceValue.wireless.subscriberNo);
            $scope.subscriberNumberList.push(subscriberServiceValue.wireless.subscriberNo);
            if (subscriberServiceValue.wireless.subscriberNo === $scope.selectedCTN) {
              if (
                subscriberServiceValue.wireless.subscriberStatus &&
                subscriberServiceValue.wireless.subscriberStatus.toLowerCase() === 'suspended' &&
                subscriberServiceValue.wireless.reason.toLowerCase() === 'los'
              ) {
                if (uteLocale.language === 'en') {
                  $scope.bringYourOwnPhoneLink = env.enBringYourOwnPhoneLink;
                } else {
                  $scope.bringYourOwnPhoneLink = env.frBringYourOwnPhoneLink;
                }
                $scope.lostDeviceStatus = true;
                lostStolenDeviceService.setReactivateNumber($scope.selectedCTN);
              } else {
                lostStolenDeviceService.setSelectedFido($scope.selectedCTN);
              }
            }
          });
        }
      });

      $scope.displayUsageDetails = function(allData) {
        // Display main blocks
        var show = false;
        // Process the highest percentage and select proper color as result decide to show in template (show =  true / false)
        show = usageService.globalDataSets(allData.data);
        $scope.showData = show;

        show = usageService.globalDataSets(allData.talk);
        $scope.showTalk = show;

        show = usageService.globalDataSets(allData.text);
        $scope.showSms = show;
      };
      $scope.repairDevicePermitted = false;

      $scope.init = function() {
        $scope.showUsageLoader = true;
        $scope.usageSuccess = false;
        $scope.usageError = false;
        $scope.showRoaming = true;

        permissionsService.getPreferences().then(
          function(data) {
            _.each(data, function(value) {
              if (value.permission && value.permission.toUpperCase() === 'FIDO_REPAIR_DEVICE_ENABLED') {
                $scope.repairDevicePermitted = true;
              }
            });
          },
          function(error) {
            $scope.repairDevicePermitted = false;
          }
        );
        var promise = httpService.send(
          'v1/wireless/prepaid/usage/view', // TODO : Need to change
          {
            accountNumber: $scope.selectedBAN,
            ctn: $scope.selectedCTN,
            language: $scope.language
          }
        );

        promise.then(
          function(result) {
            if (result.data.error || result.data.status == 'Failed') {
              $scope.showUsageLoader = false;
              $scope.usageError = true;
            } else {
              $scope.showUsageLoader = false;
              $scope.usageSuccess = true;
              console.log(result.data);
              usageService.getUsageDetails(result.data, function(_tmp) {
                if (_tmp.result === 'success') {
                  // Proceed to display
                  $scope.wd = _tmp.data;
                  console.log($scope.wd);
                  $scope.displayUsageDetails(_tmp.data);
                  if (_tmp.data.talk.length > 0) {
                    if (_tmp.data.talk.globalDisplayTotal - _tmp.data.talk.globalDisplayUsed > 0) {
                      $scope.localMins = _tmp.data.talk.globalDisplayTotal - _tmp.data.talk.globalDisplayUsed;
                    }
                  }
                }
              });

              $scope.dataIsCollapsed = true;
            }
          },
          function(reason) {
            $scope.showUsageLoader = false;
            $scope.usageError = true;
          }
        );
      };
      $scope.relaunchPage();

      var storeURL = '';
      var webmailURL = '';
      var websmsURL = '';
      var accessoryURL = '';

      if ($scope.language === 'en' || $scope.language === 'EN') {
        storeURL = env.enStoreLocator;
        webmailURL = env.enWebmailLink;
        websmsURL = env.enWebsmsLink;
        accessoryURL = env.enFidoAccessory;
      } else {
        storeURL = env.frStoreLocator;
        webmailURL = env.frWebmailLink;
        websmsURL = env.frWebsmsLink;
        accessoryURL = env.frFidoAccessory;
      }

      $scope.fidoAccessory = function() {
        window.open(accessoryURL, '_blank').focus();
      };

      $scope.fidoStore = function() {
        window.open(storeURL, 'blank').focus();
      };

      $scope.fidoWebmail = function() {
        window.open(webmailURL, '_blank').focus();
      };

      $scope.fidoWebsms = function() {
        window.open(websmsURL, '_blank').focus();
      };
      $scope.fidoWebMailSMSNoService = function() {
        uteModal.open({
          templateUrl: 'modules/my-account/wireless/webmail-fidosms-no-service.html',
          windowTemplateUrl: 'views/templates/modal/pop-up-window-modal.html',
          windowClass: 'change-caller-id-specific',
          ok: function() {},
          cancel: function() {}
        });
      };

      function fetchSSOToken() {
        var selectedAccInfo = {
          accountNumber: $stateParams.accountNumber,
          subscriberNo: $stateParams.subscriberNo,
          language: $scope.language,
          province: uteLocale.province
        };
        return tokenService.fetchSSOTokenAsPromise(selectedAccInfo);
      }

      $scope.trackPhoneRepairClaim = function() {
        const account = {
          BAN: $scope.selectedBAN,
          CTN: $scope.selectedCTN,
          userName: $scope.userEmailId
        };

        var promise = fetchSSOToken();
        promise.then(
          function(result) {
            ssoToken = result.content.token;
            uteModal.open({
              templateUrl: 'modules/my-account/prepaid/track-phone-repair-claim/track-phone-repair-claim.html',
              windowTemplateUrl: 'views/templates/modal/pop-up-window-modal.html',
              windowClass: 'track-phone-repair-claim',
              controller: [
                '$scope',
                '$modalInstance',
                function($scope, $modalInstance) {
                  trackAnalytics(account, '');
                  $scope.ok = function() {
                    document.getElementById('TOKEN').value = ssoToken;
                    document.getElementById('trackPhoneRepairClaimForm').action =
                      env.prepaid.repairServiceVendor.endpoint;
                    document.getElementById('trackPhoneRepairClaimForm').submit();
                    $modalInstance.dismiss('ok');
                    const interaction = {
                      type: 'click',
                      name: 'Redirect to Brightstar'
                    };
                    trackAnalytics(account, interaction);
                  };
                  $scope.cancel = function() {
                    $modalInstance.dismiss('cancel');
                  };
                }
              ]
            });
          },
          function(error) {
            uteModal.open({
              templateUrl: 'modules/my-account/prepaid/track-phone-repair-claim/track-phone-repair-error.html',
              windowTemplateUrl: 'views/templates/modal/pop-up-window-modal.html',
              windowClass: 'track-phone-repair-error',
              controller: [
                '$scope',
                '$modalInstance',
                function($scope, $modalInstance) {
                  trackErrorAnalytics(account, error);
                  $scope.errorMsg = 'global.label.spotifyUnavailable';
                  $scope.ok = function() {
                    $modalInstance.close();
                  };
                  $scope.cancel = function() {
                    $modalInstance.dismiss('cancel');
                  };
                }
              ]
            });

            console.log('Continue to repair portal:: SSO Token Fail', error);
          }
        );
      };

      function trackAnalytics(payload, interaction) {
        const section = window.ute.datalayer.common.service.DataLayerPredefinedSection;
        const selectedSections = [section.ACCOUNT, section.PAGE, section.SITE];
        const pageView = interaction === '' ? true : false;
        const trackPayload = constructADLPayload(payload, pageView, interaction, true);
        dataLayerService.track(trackPayload, true, selectedSections);
      }

      function trackErrorAnalytics(payload, error) {
        const section = window.ute.datalayer.common.service.DataLayerPredefinedSection;
        const selectedSections = [section.ACCOUNT, section.PAGE, section.SITE];
        const errorType = window.ute.datalayer.common.service.ErrorType;
        const errorCategory = window.ute.datalayer.common.service.ErrorCategory;
        const data = error.data;
        const errorApi = error.url ? error.url : '';
        const errPayload = constructADLPayload(payload, false, '', false);
        errPayload.events = { pageView: true, error: true };

        if (_.has(data, 'status.code')) {
          dataLayerService.trackError(
            errPayload,
            errorType.HTTP,
            data.status.code,
            data.status.codeName,
            errorCategory.SELF_SERVE,
            '',
            errorApi,
            true,
            selectedSections
          );
        } else {
          if (error.status === 404 && error.statusText === '') {
            error.statusText = 'API Not found';
          }
          dataLayerService.trackError(
            errPayload,
            errorType.HTTP,
            error.status,
            error.statusText,
            errorCategory.SELF_SERVE,
            '',
            errorApi,
            true,
            selectedSections
          );
        }
      }

      function constructADLPayload(tpayload, pageView, interaction, success) {
        const payload = {
          account: { BAN: tpayload.BAN, CTN: tpayload.CTN, userType: 'Consumer', userName: tpayload.userName },
          page: {
            name: success ? 'continue to repair portal' : 'system error modal',
            hierarchy: ['myaccount', 'prepaidWireless'],
            language: $scope.language,
            province: uteLocale.province,
            url: 'modal popup',
            Referrer: location.href
          },
          user: {
            loginStatus: true
          },
          site: {
            name: 'R'
          }
        };

        if (pageView) {
          payload.events = {
            pageView: true
          };
        }
        if (interaction) {
          payload.interaction = interaction;
          payload.events = {
            interaction: true
          };
        }
        return payload;
      }
    }
  ]);

  /* Wireless Prepaid Controller - END */
})();
